<template>
  <div class="user-profil-avatar">
    <div v-if="$store.state.core.subscriber == null">
      <div class="float-left">
        <b-skeleton
          style="border-radius: 50%"
          height="40px"
          width="40px"
        ></b-skeleton>
      </div>
      <div class="float-right ms-2 mt-2">
        <b-skeleton height="10px" width="60px"></b-skeleton>
        <b-skeleton height="10px" width="40px"></b-skeleton>
      </div>
    </div>

    <div
      v-if="$store.state.core.subscriber != null"
      class="user-profil-avatar-pic"
    ></div>
    <div
      v-if="$store.state.core.subscriber != null"
      class="user-profil-avatar-details"
    >
      <span>{{ $store.state.core.subscriber.infos.last_name ? $store.state.core.subscriber.infos.last_name : "—" }}</span>
      <span>{{ $store.state.core.subscriber.infos.msisdn ? crop_prefix($store.state.core.subscriber.infos.msisdn) : "—" }}</span>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  name: "UserAvatar",
  mounted: async function () {},
};
</script>
<style scoped lang="css">
</style>
